<template>
  <v-btn
    :icon="text === null"
    :text="isShowText"
    :color="color"
    @click="backButtonTapped()"
  >
    <v-icon :left="isShowText">mdi-arrow-left-circle</v-icon>
    <div v-if="isShowText" class="title">{{ text }}</div>
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    isShowText() {
      return this.text !== null;
    },
  },
  methods: {
    backButtonTapped() {
      this.$router.go(-1);
    },
  },
};
</script>
